import {useMutation} from '@tanstack/react-query';
import {CompanyPortalParams} from 'domain/usecases/public/sign-in/company-portal';
import {MUTATION_KEYS} from 'infra/libs/react-query/mutationKeys';
import {getCompanyPortal} from '../../services/getCompanyPortal';

export const useGetCompanyPortalMutation = () =>
	useMutation({
		mutationKey: [MUTATION_KEYS.COMPANY_PORTAL],
		mutationFn: (params: CompanyPortalParams) => getCompanyPortal(params),
	});
